import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[auPopoverFilterContent]' })
export class PopoverFilterContentDirective {
   constructor(public template: TemplateRef<any>) { }
}
